<div class="row g-3 shortlist-content">
  <div class="col-12" *ngIf="showTitle">
    <p class="mb-0"><b>SHORTLISTED CARS</b></p>
    <p>Excellent choices</p>
  </div>
  <div class="col-sm-12 col-md-{{defaultNoCols}}" *ngFor="let car of shortlistedCars;">
    <app-car-card [car]="car"></app-car-card>
  </div>
  <ng-container *ngIf="isLoading">
    <div class="col-sm-12 col-md-{{defaultNoCols}}" *ngFor="let item of vehicleLoadingCount">
      <app-vehicle-card-loader></app-vehicle-card-loader>
    </div>
  </ng-container>
  <div *ngIf="!shortlistedCars.length && !isLoading" class="d-flex justify-content-center align-items-center">
    <div class="text-center mt-4">
      <!-- <p><b>Uh Oh!</b></p> -->
      <p class="mb-4">You have not shortlisted any car yet!</p>
      <!-- <p>Check our listings to find the perfect car for yourself.</p> -->
      <app-p3-button (onClick)="browseCars()">
        EXPLORE CARS
      </app-p3-button>
    </div>
  </div>
</div>